import moment from "moment"
import { useState } from "react"
import { Loader } from "../../App"
import { InvitationModal } from "../../components/cards/InvitationModal"
import { useInvitationLocksQuery } from "../../hooks/useInvitations"

interface IProps {}

const Invitations = (props: IProps) => {
  const { data: invitations, isLoading } = useInvitationLocksQuery()
  const [openInviteModal, setOpenInviteModal] = useState(false)

  return isLoading ? (
    <Loader />
  ) : (
    <div className="flex w-full h-full justify-start items-start bg-sumo-50 flex-1 px-24 py-12 overflow-auto">
      <section className="flex flex-col w-full h-full gap-2">
        <div className="flex w-full">
          <div className="flex w-1/2 justify-start text-slate-900 font-semibold">
            <p>INVITATIONS</p>
          </div>
          <div className="flex w-1/2 justify-end text-sumo-50 font-semibold">
            <button
              className="flex gap-2 bg-sumo-550 px-6 py-2 rounded-xl justify-center items-center"
              onClick={() => setOpenInviteModal(true)}
            >
              <img
                src="/images/plus-circle.svg"
                style={{ height: "20px" }}
                alt="stats"
                loading="lazy"
              />
              Inviter
            </button>
          </div>
        </div>
        <div className="flex flex-col w-full h-full gap-2">
          <div className="flex flex-col w-full h-full">
            <div className="flex flex-row w-full border-b pb-4">
              <div className="flex w-1/4 font-bold text-sumo-500">
                Date d'invitation
              </div>
              <div className="flex w-3/4 font-bold text-sumo-500">Email</div>
            </div>
            <ul className="flex flex-col w-full h-full">
              {invitations?.map((invitation) => (
                <>
                  <li className="flex border-b py-4" key={invitation.id}>
                    <div className="flex flex-row w-full">
                      <div className="flex w-1/4 text-sumo-500">
                        {moment(invitation.created_at).format(
                          "DD/MM/YYYY [à] HH[h]mm"
                        )}
                      </div>
                      <div className="flex w-3/4 text-sumo-500">
                        <p>{invitation.email}</p>
                      </div>
                    </div>
                  </li>
                </>
              ))}
            </ul>
          </div>
        </div>
      </section>
      {openInviteModal ? (
        <InvitationModal
          closeModal={() => {
            setOpenInviteModal(false)
          }}
        />
      ) : null}
    </div>
  )
}

export default Invitations
